import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import rootReducer from './reducers';
import cryptoJs from 'crypto-js';

// Secret key for encryption
const SECRET_KEY = process.env.REACT_APP_REDUX_SECRET_KEY || "default-fallback-encryption-key";

// Create a transform to encrypt and decrypt data
const encryptTransform = createTransform(
  // Encrypt state before storing
  (inboundState) => {
    const encryptedState = cryptoJs.AES.encrypt(
      JSON.stringify(inboundState), // Stringify the state
      SECRET_KEY
    ).toString();
    return encryptedState;
  },
  // Decrypt state when rehydrating
  (outboundState) => {
    try {
      const bytes = cryptoJs.AES.decrypt(outboundState, SECRET_KEY);
      const decryptedState = JSON.parse(bytes.toString(cryptoJs.enc.Utf8)); // Parse the state back to an object
      return decryptedState;
    } catch (e) {
      console.error('Error decrypting state:', e);
      return {}; // Return an empty object on failure to prevent crashes
    }
  },
  { whitelist: ['auth', 'process'] } // Only encrypt specific reducers
);
// Persist configuration
const persistConfig = {
  key: 'state',
  storage,
  whitelist: ['auth', 'process'], // Specify which reducers to persist
  transforms: [encryptTransform], // Add the encryption transform
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the store using configureStore from Redux Toolkit
const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'], // Ignore persist actions to avoid warnings
      },
    }),
});

// Create the persistor
const persister = persistStore(store);

export { store, persister };